/** Exact-case admin login path. Any other casing shows the public website. */
export const ADMIN_LOGIN_PATH = '/KoPartnerAdmin';
